import { KnowledgeQuestionReviewContent } from './KnowledgeQuestionReviewContent';
export default KnowledgeQuestionReviewContent;